import gql from 'graphql-tag';

// `input` carries `version` alongside `defaultCoverageOptOutId` so a delete
// cannot land on a row that changed after it was listed. A lost version race
// comes back as `errorCode: 'STALE_VERSION'` with the human sentence in
// `errors[0]`. The payload has no entry object, so there is no `version` /
// `createdBy` to select here.
const deleteDefaultCoverageOptOutMutation = gql`
  mutation DeleteDefaultCoverageOptOut(
    $input: DestroyDefaultCoverageOptOutInput!
  ) {
    deleteDefaultCoverageOptOut(input: $input) {
      success
      errors
      errorCode
      defaultCoverageOptOutId
    }
  }
`;

export default deleteDefaultCoverageOptOutMutation;
